<div>
    <div class="row">
      <div class="col-2 mb-3">
        <h2 class="title-list">Role List</h2>
      </div>
      <div class="col-4">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">
            <i class="bi bi-search"></i>
          </span>
          <input
          type="text"
          class="form-control input-label"
          placeholder="Search"
          [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()"
        />
        </div>
      </div>
  
      <div class="col-2 text-end">
        <div class="col text-end">
          <button
            class="btn btn-primary"
            (click)="navigateToCreateUser()"
          >
            Create Role
          </button>
        </div>
      </div>

      <div class="col-3 text-end">
        <button
          class="btn btn-secondary"
          appTooltip="Show Archived Roles"
          (click)="isFilteredByStatus ? clearFilter() : filterByStatus(2)"
        >
          <i class="bi bi-archive"></i>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive rounded-5">
          <table class="table table-striped mb-0">
            <caption class="d-none">
              List of roles and their details
            </caption>
            <thead class="head-table">
              <tr>
                <th class="px-4 py-3 align-middle col-3">Role Name</th>
                <th class="px-4 py-3 align-middle col-3">Users by role</th>
                <th class="px-4 py-3 align-middle col-3">Status</th>
                <th class="px-4 py-3 align-middle col-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let rol of roles
                    | search : textoBusqueda : camposBusqueda
                    | slice : (currentPage - 1) * recordsPerPage : currentPage * recordsPerPage
                "
              >
                <td
                  class="px-4 py-3 align-middle"
                  [style.opacity]="rol.aRoleStatus === 0 ? '0.6' : '1'"
                  title="{{ rol.aRoleName }}"
                >
                  {{ rol.aRoleName }}
                </td>
                <td
                  class="px-4 py-3 align-middle"
                  [style.opacity]="rol.aRoleStatus === 0 ? '0.6' : '1'"
                  title="{{ rol.userCountPerRole }}"
                >
                  {{ rol.userCountPerRole }}
                </td>
                <td class="px-4 py-3 align-middle">
                  <div
                    *ngIf="rol.aRoleStatus === 0 || rol.aRoleStatus === 1"
                    class="form-check form-switch"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [(ngModel)]="rol.aRoleStatus"
                      id="flexSwitchCheckDefault"
                      [checked]="rol.aRoleStatus === 1"
                      [disabled]="!permissionsService.editPermission"
                      (change)="
                        toggleStatus($event, rol);
                        setSelectedCustomer(rol);
                        openConfirmationModal(rol)
                      "
                      data-bs-toggle="modal"
                      data-bs-target="#modalSwitch"
                    />
                  </div>
                  <div *ngIf="rol.aRoleStatus === 2">
                    <span class="archived">Archived</span>
                  </div>
                </td>
                <td class="px-4 py-3 align-middle">
                    <div class="d-flex gap-2">
                        <!-- Botón Editar con icono pencil-square -->
                        <button *ngIf="rol.aRoleStatus !== 2 && permissionsService.editPermission"
                                class="btn btn-info"
                                (click)="navigateToUpdateRole(rol)"
                                style="background-color: #d1e7dd; border: 3px solid #d1e7dd" appTooltip="Edit Role">
                            <i class="bi bi-pencil-square" style="color: #146c43"></i>
                        </button>

                        <!-- Кнопка «Удалить» со значком «Архив» -->
                        <button *ngIf="rol.aRoleStatus !== 2 && permissionsService.archivePermission"
                                class="btn btn-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#modalArchive"
                                (click)="setArchivedCustomer(rol)"
                                style="background-color: #f8d7da; border: 3px solid #f8d7da" appTooltip="Archive Role">
                            <i class="bi bi-archive" style="color: #b02a37"></i>
                        </button>

                        <!-- Кнопка «Восстановить» со значком «Архив» -->
                        <button *ngIf="rol.aRoleStatus === 2 && permissionsService.archivePermission"
                                class="btn btn-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#modalArchive"
                                (click)="setArchivedCustomer(rol)"
                                style="background-color: #7ab956; border: 3px solid #7ab956" appTooltip="Restore Role">
                          <i class="bi bi-archive"></i>
                        </button>

                        <!-- Botón View con icono eye -->
                        <button class="btn btn-success"
                                style="background-color: #cfe2ff; border: 3px solid #cfe2ff" appTooltip="View Role"
                                *ngIf="permissionsService.readPermission"
                                (click)="navigateToCustomerView(rol)">
                            <i class="bi bi-eye" style="color: #0a58ca"></i>
                        </button>
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <div class="row d-flex align-items-center justify-content-between">
      <div class="col-2">
        <label>
          Showing {{ (currentPage - 1) * recordsPerPage + 1 }} to {{ currentPage * recordsPerPage < roles.length ? currentPage * recordsPerPage : roles.length }} out of {{ roles.length }} entries
        </label>
      </div>
      <div class="col-7">
        <div class="col-12 pagination text-left ">
          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  tabindex="-1"
                  aria-disabled="true"
                  (click)="previousPage()"
                >
                  <i class="bi bi-chevron-left"></i>
                </a>
              </li>
              <ng-container *ngFor="let page of pages">
                <li class="page-item" [class.active]="page === currentPage">
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="changePage(page)"
                    >{{ page }}</a
                  >
                </li>
              </ng-container>
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a
                  class="page-link"
                  href="javascript:void(0)"
                  (click)="nextPage()"
                >
                  <i class="bi bi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    class="modal fade"
    id="modalSwitch"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">
            Role Active/Inactive
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="updateUserStatus(false)"
          ></button>
        </div>
        <div class="modal-body">
          Are you sure you want to Activate/Deactivate this role?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(false)"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(true)"
          >
            Yes, Activate/Desactivate
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Modal -->
  <div
    class="modal fade"
    id="modalArchive"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold;">Role {{isFilteredByStatus ? 'Restore' : 'Archive'}}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="updateUserStatus(false)"
          ></button>
        </div>
        <div class="modal-body">
            Are you sure you want to {{isFilteredByStatus ? 'Restore' : 'Archive'}} this role?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            (click)="updateUserStatus(false)"
          >
            Close
          </button>
          <button type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  (click)="updateUserStatus(true)">
              Yes, {{isFilteredByStatus ? 'Restore' : 'Archive'}}
          </button>
        </div>
      </div>
    </div>
  </div>
  